import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { roles } from '../consts/roles';
import { CryptoService } from './crypto.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  permissionLevel = [];
  entities = [];
  permissionGuard = [];
  userPermission = [];
  userInfo= new BehaviorSubject(null)


  constructor(private crypto: CryptoService) {

  }

  getUserInfo(){
    let userInfo = localStorage.getItem('userInfo')
    return userInfo !=null ? JSON.parse(userInfo) : null
  }
  getPermissionLevel() {
    return JSON.parse(localStorage.getItem('userInfo')).permissionLevel
  }

  getEntities() {
    return JSON.parse(localStorage.getItem('userInfo')).entities
  }
  getRefernceId() {
    return JSON.parse(localStorage.getItem('userInfo')).referenceId
  }

  getReferenceMajorId() {
    return JSON.parse(localStorage.getItem('userInfo')).referenceMajorId
  }

  isSuperAdmin() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (userInfo != null) {
      let roleId = this.crypto.decrypt(userInfo['roleId']);
      if (roleId == roles.Administrator)
        return true
    }
    return false;
  }

  getPermissionGuard() {
    this.userPermission = []
    this.permissionGuard = []

    this.permissionLevel = this.getPermissionLevel();
    this.entities = this.getEntities();

    this.permissions.forEach(entity => {
      if (this.entities.findIndex(item => item.id === entity.entityId) > -1) {
        entity.permissionLevel.forEach(level => {
          if (this.permissionLevel.findIndex(lvl => lvl.id === level.id) > -1) {
            if (level.route != "")
              this.permissionGuard.push(level.route)
            level.hasPermission = true;
          }
        })
        this.userPermission.push(entity)

      }
    })

    return this.permissionGuard;

  }


  getUserPermission() {
    this.userPermission = []
    this.permissionGuard = []

    this.permissionLevel = this.getPermissionLevel();
    this.entities = this.getEntities();

    this.permissions.forEach(entity => {
      if (this.entities.findIndex(item => item.id === entity.entityId) > -1) {
        entity.permissionLevel.forEach(level => {
          if (this.permissionLevel.findIndex(lvl => lvl.id === level.id) > -1) {
            if (level.route != "")
              this.permissionGuard.push(level.route)
            level.hasPermission = true;
          }
        })
        this.userPermission.push(entity)

      }
    })

    return this.userPermission;

  }

  getUserEntityPermission(entityId: string) {
    let _Permission = this.getUserPermission()

    let userPermission = new UserPermisionLevels()

    let ind = _Permission.findIndex(item => item.entityId === entityId);
    if (ind > -1) {
      userPermission.add = _Permission[ind].permissionLevel[0].hasPermission;
      userPermission.edit = _Permission[ind].permissionLevel[1].hasPermission;
      userPermission.delete = _Permission[ind].permissionLevel[2].hasPermission;
      userPermission.activate = _Permission[ind].permissionLevel[3].hasPermission;
      userPermission.list = _Permission[ind].permissionLevel[4].hasPermission;
      userPermission.view = _Permission[ind].permissionLevel[5].hasPermission;
      userPermission.Reports = _Permission[ind].permissionLevel[6].hasPermission;

    }
    return userPermission;
  }

  isNotHasPermission(routerLink) {
    let hasPer = false;
    this.permissionLevel = this.getPermissionLevel();
    this.entities = this.getEntities();

    this.permissions.forEach(entity => {
      entity.permissionLevel.forEach(level => {
        if (level.route === routerLink) {
          hasPer = true; return;
        }
      })
    })
    return hasPer;
  }

  Entities = environment.Entities;
  PermissionLevels = environment.PermissionLevels;



  permissions = [
    





  ]



}

export class UserPermisionLevels {
  constructor() {
    this.add = false
    this.edit = false
    this.delete = false
    this.activate = false
    this.list = false
    this.view = false
    this.Reports = false
  }
  add: boolean
  edit: boolean
  delete: boolean
  list: boolean
  view: boolean
  activate: boolean
  Reports: boolean
}